export const TEST_AUTHENTICATED = 'authenticated';
export const TEST_AWAITING_AUTHORIZATION = 'awaitingAuthorization';
export const TEST_AWAITING_LAUNCH = 'awaitingLaunch';
export const TEST_LAUNCHED = 'testLaunched'; //this state will cause load of learnosity
export const TEST_INSESSION = 'inSession'; //after test:start
export const TEST_DENIED = 'denied';
export const TEST_PAUSED = 'paused';
export const TEST_DUPLICATE = 'duplicate';
export const TEST_ABORT = 'abort';

export const PAUSED_BY_TESTER = 'tester';
export const PAUSED_BY_PROCTOR = 'proctor';
export const PAUSED_BY_SYSTEM = 'system';

export const SAVE_ERROR = 'error';
export const SAVE_SUCCESS = 'success';

export const MIN_CONSECUTIVE_ERRORS = 3;
